import { Color } from 'constants/enums';

export interface IColor {
  main: string;
  hover: string;
  active: string;
}

export type TColor = {
  [key in Color]: IColor;
};

export const COLORS: TColor = Object.freeze({
  white: {
    main: '#E5E5E5',
    hover: '#BEBFBD',
    active: '#8F918E',
  },
  black: {
    main: '#070806',
    hover: '#121311',
    active: '#121311',
  },
  darkGrey: {
    main: '#1a1c1a',
    hover: '#171A15',
    active: '#1D1F1B',
  },
  grey: {
    main: '#1A1C18',
    hover: '#242622',
    active: '#2F312D',
  },
  lightGrey: {
    main: '#6C6D6A',
    hover: '#565753',
    active: '#444541',
  },
  red: {
    main: '#6A2A2A',
    hover: '#381616',
    active: '#1F0C0C',
  },
  green: {
    main: '#58BD88',
    hover: '#009466',
    active: '#3CA76F',
  },
});
